import React, { useEffect } from 'react';
import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';

interface OnboardingCompletionProps {
  name: string;
  onDone: () => void;
}

const OnboardingCompletion: React.FC<OnboardingCompletionProps> = ({ name, onDone }) => {
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(onDone, 2500);
    return () => clearTimeout(timer);
  }, [onDone]);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.97 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] }}>
      <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
        {t('Agent.OnboardingCompletionTitle', { name })}
      </h2>
      <p className="text-white/50 text-lg mb-6">{t('Agent.OnboardingCompletionSubtitle')}</p>
      <p className="text-[#7c6cf6] text-lg font-medium">{t('Agent.OnboardingCompletionMessage')}</p>
    </motion.div>
  );
};

export default OnboardingCompletion;
